import { useEffect, useState } from "react";
import { X, Printer, Eye } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

/**
 * Dialogue « Impression de la DAJ » — parité legacy frmDAJPrint.
 * Cases : DAJ (toujours), Autorisation et consentement (requérant),
 * Autorisation et consentement (conjoint(e)), Déclaration additionnelle
 * (désactivée — rapport à venir), Notes non imprimées (usage interne).
 * Génère un PDF combiné (un rapport par page) prévisualisable avant impression.
 */
export default function DajPrintModal({ seq, conjointAvailable, onClose }) {
  const [autr, setAutr] = useState(true);
  const [autc, setAutc] = useState(!!conjointAvailable);
  const [notes, setNotes] = useState(true);

  useEffect(() => {
    const onKey = (e) => { if (e.key === "Escape") onClose(); };
    document.addEventListener("keydown", onKey);
    return () => document.removeEventListener("keydown", onKey);
  }, [onClose]);

  const buildUrl = (auto) => {
    const p = new URLSearchParams();
    if (autr) p.set("autr", "true");
    if (autc) p.set("autc", "true");
    if (notes) p.set("notes", "true");
    if (auto) p.set("auto", "true");
    return `${API}/daj/${encodeURIComponent(seq)}/print-view?${p.toString()}`;
  };

  const handleApercu = () => window.open(buildUrl(false), "_blank", "noopener,noreferrer");

  const handlePrint = () => { window.open(buildUrl(true), "_blank", "noopener,noreferrer"); };

  const cb = { marginRight: 8, transform: "scale(1.15)" };
  const row = { display: "flex", alignItems: "center", gap: 4, fontSize: 14, padding: "5px 0", fontWeight: 600 };

  return (
    <div style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,0.5)",
                  display: "flex", justifyContent: "center", alignItems: "center", zIndex: 2000 }}
         onClick={(e) => { if (e.target === e.currentTarget) onClose(); }}
         data-testid="daj-print-modal">
      <div style={{ background: "#f0f0f0", border: "2px solid #003366",
                    width: 520, maxWidth: "95vw", maxHeight: "92vh",
                    display: "flex", flexDirection: "column" }}>
        <div style={{ background: "#003366", color: "#fff", padding: "6px 14px",
                      fontWeight: "bold", fontSize: 13, display: "flex",
                      justifyContent: "space-between", alignItems: "center" }}>
          <span>Impression de la DAJ — <strong>{seq}</strong></span>
          <X size={18} style={{ cursor: "pointer" }} onClick={onClose} data-testid="daj-print-close" />
        </div>

        <div style={{ padding: "16px 22px", overflow: "auto" }}>
          <div style={row}>
            <input type="checkbox" style={cb} checked disabled data-testid="daj-print-daj" />
            DAJ
          </div>
          <div style={row}>
            <input type="checkbox" style={cb} checked={autr}
                   onChange={(e) => setAutr(e.target.checked)} data-testid="daj-print-autr" />
            Autorisation et consentement
          </div>
          <div style={{ ...row, opacity: conjointAvailable ? 1 : 0.5 }}>
            <input type="checkbox" style={cb} checked={autc} disabled={!conjointAvailable}
                   onChange={(e) => setAutc(e.target.checked)} data-testid="daj-print-autc" />
            Autorisation et consentement (conjoint(e))
          </div>
          <div style={{ ...row, opacity: 0.5 }} title="Rapport à venir">
            <input type="checkbox" style={cb} checked={false} disabled data-testid="daj-print-declaadd" />
            Déclaration additionnelle
          </div>
          <div style={row}>
            <input type="checkbox" style={cb} checked={notes}
                   onChange={(e) => setNotes(e.target.checked)} data-testid="daj-print-notes" />
            Notes non imprimées (Pour usage interne seulement)
          </div>

          <div style={{ display: "flex", gap: 8, marginTop: 16, justifyContent: "flex-end" }}>
            <button className="win-btn" onClick={handleApercu} data-testid="daj-print-apercu"
                    style={{ padding: "5px 14px", display: "flex", alignItems: "center", gap: 6 }}>
              <Eye size={15} /> Aperçu
            </button>
            <button className="win-btn" onClick={handlePrint} data-testid="daj-print-print"
                    style={{ padding: "5px 14px", display: "flex", alignItems: "center", gap: 6 }}>
              <Printer size={15} /> Imprimer
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
